<template>
  <DModal :show-close="false" :isBgOverlay="true" @close="$emit('close')" :appendToBody="true"
          style="z-index: 12312312312312" :placeInTop="true">
    <div class="d-modal text-dark" id="d-create-task-for-user" slot="insertComponent">
      <div class="d-modal__header">
        <h2>Status fra oprettelsen</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="d-modal__content">
        <Tabs :tabs="computedTabs"
              :selected="selectedTab"
              @select="selectedTab = $event">
        </Tabs>
        <table class="do-table marg-1-top">
          <thead>
          <tr>
            <th>Navn</th>
            <th>Status</th>
            <th> {{ selectedTab === 'error' ? 'Fejlbeskrivelse' : '' }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="user in usersFiltered" :key="user.user_id">
            <td>{{ user.user_name }}</td>
            <td>
              <span v-if="user.result === 'ok'">✔️</span>
              <span class="italic" v-else>Ikke oprettet</span>
            </td>
            <td>
              <span v-if="user.result === 'error'" class="do-warning">
                {{ errorDescription(user.error) }}
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../common/DModal.vue'
import ModalConfirmation from '../Modals/ModalConfirmation.vue'
import Tabs from '../common/Tabs.vue'

export default {
  components: {Tabs, ModalConfirmation, DModal},
  props: {
    users: {
      type: Array,
      default: () => []
    },
    schoolId: {},
    schoolYearId: {},
    schoolYear: {}
  },
  data () {
    return {
      selectedTab: 'error'
    }
  },
  computed: {
    usersSorted () {
      return this.users.slice().sort((a, b) =>
        a.user_name.localeCompare(b.user_name, 'da', {
          numeric: true,
          sensitivity: 'base'
        })
      )
    },
    errorUsers () {
      return this.usersSorted.filter(u => u.result === 'error')
    },
    okUsers () {
      return this.usersSorted.filter(u => u.result === 'ok')
    },
    computedTabs () {
      return [
        {id: 'error', title: `Ikke oprettet (${this.errorUsers.length})`},
        {id: 'ok', title: `Oprettet korrekt (${this.okUsers.length})`}
      ]
    },
    usersFiltered () {
      return this.usersSorted.filter(u => u.result === this.selectedTab)
    }
  },
  methods: {
    errorDescription (error) {
      if (error === 'No norm') return 'Ingen bruttonorm eller ansættelsesperiode'
      if (error === 'No user year') return 'Ingen bruttonorm eller ansættelsesperiode'
      return error
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-modal {
  width: 1000px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
}

.d-modal__buttons {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 2rem;
  border-top: 1px solid #eee;
  margin: 0;
}

.d-modal__buttons > div {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.d-modal__content {
  padding: 1rem;
  overscroll-behavior: contain;
}

.d-input-group--toggler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
}

.d-input-group--toggler.d-input-group--toggler--active > .d-label {
  color: var(--dark-blue);
}

.d-input-group--toggler > .d-label {
  margin-bottom: 0;
  cursor: pointer;
}

.d-input-group--toggler:hover {
  background: #f0f8ff;
}

.d-input-group .d-input {
  height: 34px;
}

.d-input-group {
  margin-bottom: 2rem;
}

.d-modal__content {
  max-height: calc(100vh - 52px - 50px);
  overflow-y: auto;
}

.do-form-row {
  display: flex;
  gap: 1rem;
}

.do-form-row > div {
  flex: 1;
}

.height-34 {
  height: 34px;
  margin-top: 0.25rem;
}

</style>



// WEBPACK FOOTER //
// ShowResponse.vue?64b6c37e